import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './layout/layout.module';
import { McApiClientModule } from './mc-api-client/mc-api-client.module';
import { GepardModule } from './gepard/gepard.module';
import { SeasonsModule } from './seasons/seasons.module';

@NgModule({
  imports: [
    RouterModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutModule,
    McApiClientModule,
    GepardModule,
    SeasonsModule
  ],
  exports: [
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    DecimalPipe,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
